import helpers from '@/store/helpers'

const Generic = {
  namespaced: true,
  state: {
    cities: null,
    docStates: null,
    transportations: null,
    accomodations: null,
    costTypes: null,
    allDocStates: null,
    outstandingStates: null,
    sppdSumGroup: null
  },
  mutations: {
    loadCities (state, payload) {
      state.cities = Object.assign([], payload)
    },
    loadDocStates (state, payload) {
      state.docStates = Object.assign([], payload)
    },
    loadModa (state, payload) {
      state.moda = Object.assign([], payload)
    },
    loadTransportations (state, payload) {
      state.transportations = Object.assign([], payload)
    },
    loadAccomodations (state, payload) {
      state.accomodations = Object.assign([], payload)
    },
    loadCostTypes (state, payload) {
      state.costTypes = Object.assign([], payload)
    },
    loadAllDocStates (state, payload) {
      state.allDocStates = Object.assign([], payload)
    },
    loadOutstandingStates (state, payload) {
      state.outstandingStates = Object.assign([], payload)
    },
    loadSppdSumGroup (state, payload) {
      state.sppdSumGroup = Object.assign([], payload)
    },
    reset (state, payload) {
      state.cities = null
      state.docStates = null
      state.transportations = null
      state.accomodations = null
      state.costTypes = null
      state.allDocStates = null
      state.outstandingStates = null
      state.sppdSumGroup = null
    }
  },
  actions: {
    refreshCities: (context, payload) => helpers.refresh(context, payload,
      {backend: 'generic', method: 'getCitiesUsingGET', mutation: 'loadCities', state: 'cities'}),
    listCities: (context, payload) => helpers.list(context, payload, {action: 'refreshCities', state: 'cities'}),
    refreshDocStates: (context, payload) => helpers.refresh(context, payload,
      {backend: 'generic', method: 'getDocumentStateUsingGET', mutation: 'loadDocStates', state: 'docStates'}),
    listDocStates: (context, payload) => helpers.list(context, payload, {action: 'refreshDocStates', state: 'docStates'}),
    refreshTransportations: (context, payload) => helpers.refresh(context, payload,
      {backend: 'generic', method: 'getTransportationUsingGET', params: {type: 'transportation'}, mutation: 'loadTransportations', state: 'transportations'}),
    listTransportations: (context, payload) => helpers.list(context, payload, {action: 'refreshTransportations', state: 'transportations'}),
    refreshAccomodations: (context, payload) => helpers.refresh(context, payload,
      {backend: 'generic', method: 'getTransportationUsingGET', params: {type: 'accomodation'}, mutation: 'loadAccomodations', state: 'accomodations'}),
    listAccomodations: (context, payload) => helpers.list(context, payload, {action: 'refreshAccomodations', state: 'accomodations'}),
    refreshCostTypes: (context, payload) => helpers.refresh(context, payload,
      {backend: 'generic', method: 'getCostTypeUsingGET', mutation: 'loadCostTypes', state: 'costTypes'}),
    listCostTypes: (context, payload) => helpers.list(context, payload, {action: 'refreshCostTypes', state: 'costTypes'}),
    refreshAllDocStates: (context, payload) => helpers.refresh(context, payload,
      {backend: 'generic', method: 'getDocumentStateAllUsingGET', mutation: 'loadAllDocStates', state: 'allDocStates'}),
    listAllDocStates: (context, payload) => helpers.list(context, payload, {action: 'refreshAllDocStates', state: 'allDocStates'}),
    refreshOutstandingStates: (context, payload) => helpers.refresh(context, payload,
      {backend: 'generic', method: 'getSppdOutstandingStateAllUsingGET', mutation: 'loadOutstandingStates', state: 'outstandingStates'}),
    listOutstandingStates: (context, payload) => helpers.list(context, payload, {action: 'refreshOutstandingStates', state: 'outstandingStates'}),
    refreshSppdSumGroup: (context, payload) => helpers.refresh(context, payload,
      {backend: 'generic', method: 'getSppdSummaryGroupAllUsingGET', mutation: 'loadSppdSumGroup', state: 'sppdSumGroup'}),
    listSppdSumGroup: (context, payload) => helpers.list(context, payload, {action: 'refreshSppdSumGroup', state: 'sppdSumGroup'}),
    reset: (context, payload) => context.commit('reset')
  }
}

export default Generic



// WEBPACK FOOTER //
// ./src/store/master/Generic.js